import { AbstractControl, ValidatorFn } from '@angular/forms';

export function requiredIf(condition: () => boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const invalid = condition() && (control.value == null || control.value === '');
    return invalid ? { required: true } : null;
  };
}
